var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-body", on: { click: _vm.appClick } },
    [
      _c("input-area", { attrs: { "result-area-ready": _vm.resultAreaReady } }),
      _vm._v(" "),
      _vm.hasResults ? _c("result-area", { ref: "results" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e3211d3", { render: render, staticRenderFns: staticRenderFns })
  }
}